// 📁 src/context/DomainContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '@api';
import { useAuth } from './AuthContext';

const DomainContext = createContext();

export const DomainProvider = ({ children }) => {
 const [organization, setOrganization] = useState(null);
 const [loadingDomain, setLoadingDomain] = useState(true);
 // const { isAuthenticated } = useAuth();
 const location = useLocation();
 const pathname = location.pathname;
 const rawHostname = window.location.hostname.replace(/^www\./, '');
 const hostname = rawHostname.endsWith('.localhost')
  ? rawHostname.replace('.localhost', '.com')
  : rawHostname;

 const isLocalhost = hostname === 'localhost';
 const isSaaSRootDomain = ['sportinghip.com'].includes(hostname);
 const isCustomDomain = !isLocalhost && !isSaaSRootDomain;
 const domain = isCustomDomain ? hostname : null;
 const RESERVED_ROUTES = [
  "dashboard",
  "login",
  "directory",
  "superadmin",
  "account",
  "sport",
  "state",
  "county",
  "leagues",
  "about",
  "privacy",
  "terms",
  "register",
  "verify-email",
  "forgot-password",
  "reset-password",
  "sandbox",
  "profile"
 ];

 const firstPathSegment = pathname.split("/").filter(Boolean)[0] || null;
 const slugFromPath =
  firstPathSegment && !RESERVED_ROUTES.includes(firstPathSegment)
   ? firstPathSegment
   : null;

 const slug = !isCustomDomain ? slugFromPath : null;

 useEffect(() => {

   const fetchOrg = async () => {
     setLoadingDomain(true);
     try {
       if (isCustomDomain) {

         const res = await api.get(`/api/organizations/domain/${hostname}`);

         const org = res.data.organization || null;
         const settings = res.data.settings || null;
         setOrganization(
           org
             ? {
               ...org,
               theme_mode: settings?.theme_mode || org.theme_mode || "light",
               primary_color:
                 settings?.primary_color || org.primary_color || "#111111",
               logo_url: settings?.logo_url || org.logo_url || "",
             }
             : null
         );
       } else if (slugFromPath) {
         const res = await api.get(`/api/organizations/slug/${slugFromPath}`);

         const org = res.data.organization || null;
         const settings = res.data.settings || null;
         setOrganization(
           org
             ? {
               ...org,
               theme_mode: settings?.theme_mode || org.theme_mode || "light",
               primary_color:
                 settings?.primary_color || org.primary_color || "#111111",
               logo_url: settings?.logo_url || org.logo_url || "",
             }
             : null
         );
       } else {
         setOrganization(null);
       }
     } catch (err) {
       setOrganization(null);
     } finally {
       setLoadingDomain(false);
     }
   };
  fetchOrg();
 }, [hostname, slugFromPath, isCustomDomain ]); // ✅ pathname removed


 return (
  <DomainContext.Provider
   value={{
    organization,
    loadingDomain,
    slug,
    domain,
    hostname,
    isLocalhost,
    isSaaSRootDomain,
    isCustomDomain,
   }}
  >
   {children}
  </DomainContext.Provider>
 );
};

export const useDomain = () => useContext(DomainContext);
